import Player from 'source/app/domain/Player';
import Maths from 'source/app/services/Maths';
import { IMultipliedKips } from './IKipsMultiplier';
import { Sounds } from 'source/app/services/Sound/Sounds';

export default function GetMultipliedKips(initialKips: number) {
	if (initialKips <= 0) {
		throw new Error('Kips must be a positive number');
	}

	const randomNumber = Maths.GetSingleRandomNumber(10);

	let multipliedKips: IMultipliedKips = {
		initialKips,
		multiplier: 0,
		image: '',
		title: '',
		message: '',
		sound: undefined,
		multiplierAdjustment: 0,
		earlyBirdAdjustment: 0,
		deepWorkBonusAdjustment: 0,
		tooFarAheadAdjustment: 0,
		finalKips: initialKips
	};

	switch (randomNumber) {
		case 9:
			multipliedKips = {
				...multipliedKips,
				multiplier: 0.5,
				image: 'checked_banner',
				title: 'Amazing!',
				message: 'The winds carry you and you earn 50% more kips!',
				sound: Sounds.shoutMarkedForDeath,
				shockBackgroundColor: '#65a600'
			};
			break;

		case 8:
			multipliedKips = {
				...multipliedKips,
				multiplier: 0,
				image: 'dragon_intense',
				title: 'Nice!',
				message: 'You mis-step but still manage to parry',
				sound: Sounds.shoutThrowVoice
			};
			break;

		case 7:
			multipliedKips = {
				...multipliedKips,
				multiplier: 0,
				image: 'checked_banner',
				title: 'Great job!',
				message: 'You deal a hard strike!',
				sound: Sounds.shoutWhirlwindsprint
			};
			break;

		case 6:
			multipliedKips = {
				...multipliedKips,
				multiplier: 0,
				image: 'checked_sketch',
				title: 'Sweet!',
				message: 'The dragon will remember your strike!',
				sound: Sounds.shoutCallDragon
			};
			break;

		case 5:
			multipliedKips = {
				...multipliedKips,
				multiplier: 0,
				image: 'checked_sketch',
				title: 'Way to go!',
				message: 'You deal a solid blow!',
				sound: Sounds.shoutCallOfValor
			};
			break;

		case 2:
			multipliedKips = {
				...multipliedKips,
				multiplier: -0.25,
				image: 'dragon_mild',
				title: 'Yikes!',
				message: 'You lose a quarter of your kips to a counter-attack',
				sound: Sounds.shoutBendWill,
				shockBackgroundColor: 'red'
			};
			break;

		default:
			multipliedKips = {
				...multipliedKips,
				multiplier: 0,
				image: 'checked_sketch',
				title: 'Nice work!',
				message: 'You strike hard and the dragon is stunned',
				sound: Sounds.shoutDisarm
			};
			break;
	}

	// Calculate +/- adjustments
	multipliedKips.multiplierAdjustment = Math.ceil(
		multipliedKips.initialKips * multipliedKips.multiplier
	);

	multipliedKips.earlyBirdAdjustment = GetEarlyBirdAdjustment(multipliedKips);

	multipliedKips.tooFarAheadAdjustment = GetTooFarAheadAdjustment(
		multipliedKips
	);

	multipliedKips.deepWorkBonusAdjustment = GetDeepWorkBonusAdjustment(
		multipliedKips
	);

	multipliedKips.finalKips =
		multipliedKips.initialKips +
		multipliedKips.earlyBirdAdjustment +
		multipliedKips.multiplierAdjustment +
		multipliedKips.tooFarAheadAdjustment +
		multipliedKips.deepWorkBonusAdjustment;

	return multipliedKips;
}

function GetEarlyBirdAdjustment(multipliedKips: IMultipliedKips) {
	if (Player.HasMetDailyTarget || Player.IsTooFarAhead) {
		return 0;
	}

	return (
		Math.ceil(multipliedKips.initialKips / 5) * 5 -
		multipliedKips.initialKips
	);
}

function GetDeepWorkBonusAdjustment(multipliedKips: IMultipliedKips) {
	const deepWorkKipsTarget = 30;
	const bonusAmount = Maths.GetSingleRandomNumber(9);
	return multipliedKips.initialKips === deepWorkKipsTarget ? bonusAmount : 0;
}

function GetTooFarAheadAdjustment(multipliedKips: IMultipliedKips) {
	const HalfOf = (value: number) => Math.floor(value / 2);
	return Player.IsTooFarAhead ? -1 * HalfOf(multipliedKips.initialKips) : 0;
}
	